import script from "./QuestionnaireQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionnaireQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionnaireQuestion.vue?vue&type=style&index=0&id=54b8cd1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54b8cd1c"]])

export default __exports__